import { render, staticRenderFns } from "./Nationality.vue?vue&type=template&id=6d52495c"
import script from "./Nationality.vue?vue&type=script&lang=js"
export * from "./Nationality.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports